export const ListActionsComponent = {
  templateUrl: './app/ajs/_shared/components/list-actions/list-actions.component.html',
  bindings: {
    showActions: '<',
    totalItems: '=',
    totalItemsSelected: '=',
    label: '@',
    updateItems: '&',
    hideDeleteButton: '<',
    hideActivateButton: '<',
    permissions: '=',
    onUnselectCheckBoxes: '&',
  },
  controller: ListActionsController,
  controllerAs: 'vm',
};

function ListActionsController() {
  var vm = this;

  vm.selectedLabel = vm.totalItemsSelected < 9 ? 'SELECTED' : 'SELECTEDS';

  vm.cancel = function () {
    return vm.onUnselectCheckBoxes();
  };
}
